import React, { useState, useEffect, useRef } from 'react';
import { Field } from '../../gs-component-form';
import { objectifyAddressComponents } from '../helpers';

interface LocationProps {
  onPlaceSelect?: () => void;
}

declare const google: any;

const Location = (props: any) => {
  const { form, onPlaceSelect, ...fieldProps } = props;

  const inputRef = useRef(null);
  const [googleLoaded, setGoogleLoaded] = useState(false);

  const existingLibraryScript = () => {
    return (
      document.getElementById('location-autocomplete-library') ||
      document.querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"]')[0]
    );
  };

  const libraryHasLoaded = (): boolean => {
    // eslint-disable-line class-methods-use-this
    return typeof google !== 'undefined';
  };

  // Load google on first render
  useEffect(() => {
    const googleApiKey = process.env.GOOGLE_API_KEY;

    function addAutocompleteLibrary(): void {
      const scriptTag = document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.id = 'location-autocomplete-library';
      if (googleApiKey) {
        scriptTag.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
      }

      // TODO: Should we support this?
      //else if (this.props.googlePlacesLibraryURL) {
      //  scriptTag.src = this.props.googlePlacesLibraryURL;
      //}

      (document.head || document.body).appendChild(scriptTag);
      scriptTag.addEventListener('load', () => {
        setGoogleLoaded(true);
      });
    }

    const libraryScript = existingLibraryScript();
    if (libraryHasLoaded()) {
      setGoogleLoaded(true);
    } else if (libraryScript) {
      libraryScript.addEventListener('load', () => setGoogleLoaded(true));
    } else {
      addAutocompleteLibrary();
    }
  }, []);

  useEffect(() => {
    if (!googleLoaded) return;
    if (!inputRef.current) return;

    const autoComplete = new google.maps.places.Autocomplete(inputRef.current);
    autoComplete.setFields(['name', 'formatted_address', 'address_components', 'place_id']);
    autoComplete.addListener('place_changed', () => {
      const place = objectifyAddressComponents(autoComplete.getPlace().address_components);

      const street1 = place.street_number ? `${place.street_number} ${place.route}` : place.route;
      form.setFieldValue('address.street1', street1 || '');
      form.setFieldValue('address.city', place.locality || place.sublocality);
      form.setFieldValue('address.state', place.administrative_area_level_1);
      form.setFieldValue('address.country', place.country);
      form.setFieldValue('address.zip', place.postal_code);
      onPlaceSelect && onPlaceSelect();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [googleLoaded, inputRef]);

  const inputRefCallback = (input: any) => {
    inputRef.current = input;
  };

  fieldProps.form = form;
  return <Field type="text" inputRef={inputRefCallback} {...fieldProps} />;
};

export default Location;
